import React from "react";
import service_four from "../images/debt-consolidation.webp";
import { Link } from "react-router-dom";
import ChatButton from "../components/ChatButton";


const DebtConsolidation = () => {
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper">
          <div className="service_page_banner_wrapper_overlay">
            <h2>Instant/Emergency Loan</h2>
          </div>

          <div className="text_content_wrapper">
            <div className="text_content">
              {/* <div className="content_banner">
                <img src={service_four} alt="" />
              </div> */}
              <div>
                <h2 className="page_title mt30 mb20">Instant/Emergency Loan</h2>

                <p>As one might guess from the name, our Instant/Emergency Loan is specifically designed to tackle urgent, unexpected/unforeseen expenses or medical emergency expenses. This type of unsecured personal loan is highly suitable where time is of the essence. For instance, your car broke down all of a sudden, or your car suffered heavy damage in an accident, and you have little or no money left. Another instance could be a medical emergency requiring immediate arrangement of funds. </p>
                <p>Other than these two examples, your credit card repayment date is approaching, but you are financially constrained, you are about to miss your EMIs, or you have to pay your rent and bills on an urgent basis. Similarly, multiple circumstances create an urgent necessity for funds to swiftly handle them. That’s when CreduMoney steps in with its effective Instant/Emergency Loan, transferred directly to your bank account	at lightning speed, precisely just 10 minutes. </p>
                <p>Why is our Instant/Emergency Loan best suited to meet urgent financial obligations? Firstly, we facilitate you to apply for a loan from anywhere. Whether you’re in a hospital, a wedding, an office or a living room, you can effortlessly apply digitally with just a few taps on your mobile. Secondly, the application process is 100% paperless, eliminating the hassle of photocopying or scanning documents. Thirdly and most importantly, we don’t check CIBIL. Apart from that, we neither demand collateral nor impose hidden charges. </p>

              </div>
              <div className="button_container flex justify-center">
                <Link to="/apply-now">Apply Now</Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default DebtConsolidation;
